/* Lookbook · v2 (Nira, 12-oct-2026). Pila fija como oflyn.fr/pages/lookbook: la foto que sube entra con un zoom suave,
   la tapada se oscurece, el raíl enmarca la activa y quita las ya vistas; en móvil, los trípticos se deslizan con puntos.
   Portada: «LOOKBOOK» ajustado al ancho exacto, la palabra se queda atrás al bajar (profundidad) y cada figura lleva a su look. */
(function () {
  var lb = document.querySelector('.lb');
  if (!lb) return;
  var figs = [].slice.call(lb.querySelectorAll('[data-lb-f]'));
  var ths = [].slice.call(lb.querySelectorAll('.lb-th[data-lb-go]'));
  var hero = lb.querySelector('[data-lb-hero]'), word = lb.querySelector('[data-lb-fit]');
  var stack = lb.querySelector('.lb-stack');
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var T = 120, act = -1, tick = false;

  function offset() {
    // altura de la cabecera en reposo (anuncio + menú): se esconde al bajar, así que no se mide en cada scroll
    var h = document.querySelector('header.hd'), an = document.querySelector('.ann');
    var b = (h ? h.offsetHeight : 0) + (an && document.body.classList.contains('has-ann') ? an.offsetHeight : 0);
    var t = Math.round(b + (innerWidth < 768 ? 10 : 24));
    if (t !== T) { T = t; lb.style.setProperty('--t', t + 'px'); }
  }

  // «LOOKBOOK» de borde a borde: la línea más ancha (una en escritorio, LOOK/BOOK en móvil) ocupa el ancho menos los márgenes
  function fit() {
    if (!hero || !word) return;
    hero.style.setProperty('--fs', '100px');
    var g = parseFloat(getComputedStyle(lb).getPropertyValue('--g')) || 16;
    var sp = word.querySelectorAll('span'), r = word.getBoundingClientRect(), w = 0;
    if (getComputedStyle(word).flexDirection === 'column') { for (var k = 0; k < sp.length; k++) w = Math.max(w, sp[k].getBoundingClientRect().width); }
    else w = sp[sp.length - 1].getBoundingClientRect().right - sp[0].getBoundingClientRect().left;
    if (w > 0) hero.style.setProperty('--fs', (100 * (hero.clientWidth - 2 * g) / w).toFixed(2) + 'px');
  }

  function frame() {
    tick = false;
    if (hero && !rm) {
      var y = scrollY;
      if (y < hero.offsetHeight * 1.2) hero.style.setProperty('--py', (y * 0.34).toFixed(1) + 'px');
    }
    var vh = innerHeight, a = 0;
    for (var i = 0; i < figs.length; i++) {
      var r = figs[i].getBoundingClientRect();
      if (r.top <= T + 2) a = i;
      var p = Math.min(1, Math.max(0, (r.top - T) / Math.max(1, vh - T)));
      if (!rm) figs[i].style.setProperty('--s', (1 + 0.1 * p).toFixed(4));
      var n = figs[i + 1], d = 0;
      if (n) {
        var q = (n.getBoundingClientRect().top - T) / Math.max(1, vh - T);
        d = 1 - Math.min(1, Math.max(0, q));
      }
      figs[i].style.setProperty('--d', d.toFixed(3));
    }
    if (a !== act) {
      act = a;
      ths.forEach(function (t, k) {
        t.classList.toggle('is-active', k === a);
        t.classList.toggle('is-prev', k < a);
        if (k === a) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
  }
  function ask() { if (!tick) { tick = true; requestAnimationFrame(frame); } }

  [].slice.call(lb.querySelectorAll('[data-lb-go]')).forEach(function (t) {
    t.addEventListener('click', function (ev) {
      ev.preventDefault();
      var i = +t.getAttribute('data-lb-go');
      var gap = parseFloat(getComputedStyle(stack).rowGap) || 0;
      var y = stack.getBoundingClientRect().top + scrollY + i * (figs[0].offsetHeight + gap) - T;
      scrollTo({ top: Math.max(0, y), behavior: rm ? 'auto' : 'smooth' });
    });
  });

  [].slice.call(lb.querySelectorAll('[data-lb-tri]')).forEach(function (tri) {
    var dots = tri.parentNode.querySelectorAll('.lb-dots i');
    tri.addEventListener('scroll', function () {
      var k = Math.round(tri.scrollLeft / Math.max(1, tri.clientWidth));
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('on', j === k);
    }, { passive: true });
  });

  offset(); fit(); frame();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(); });
  addEventListener('scroll', ask, { passive: true });
  addEventListener('resize', function () { offset(); fit(); ask(); });
  addEventListener('load', function () { offset(); fit(); ask(); });
})();
